import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    page;
    size;
    total;
    data;
    mounted() {
        // this.initWebsocket();
    }
    handleSizeChange(size) {
        this.$emit('on-size-change', size);
    }
    handleCurrentChange(curr) {
        this.$emit('on-curr-change', curr);
    }
    handleSelectionChange(val) {
        this.$emit('on-selection-change', val);
    }
    handleSortChange(val) {
        this.$emit('sort-change', val);
    }
    getRowKey(row) {
        const res = row.id;
        return res;
    }
    clearSelection() {
        this.$refs.multipleTable.clearSelection();
    }
    handleFilterChange(filters) {
        this.$emit('on-filter', filters);
    }
};
__decorate([
    Prop({ default: 1 })
], default_1.prototype, "page", void 0);
__decorate([
    Prop({ default: 10 })
], default_1.prototype, "size", void 0);
__decorate([
    Prop({ default: 10 })
], default_1.prototype, "total", void 0);
__decorate([
    Prop({ default: 10 })
], default_1.prototype, "data", void 0);
default_1 = __decorate([
    Component({
        name: 'XplorerTable',
    })
], default_1);
export default default_1;
